export const awsQueryKeys = {
  iamRoleMetadata: (teamId: string) =>
    ['aws/metadata/iam-role', { teamId }] as const
}
